export default __webpack_public_path__ + "static/media/img-08.95dda34b.png";